<app-header [profileImg]="profilePicture" [profile]="profile" [isLoadingData]="isLoadingData"></app-header>

<ng-container *ngIf="isLoadingData">
    <div class="text-center m-3 loadingContainer">
        <!-- <i class="far fa-spinner fa-spin fa-2x"></i> -->
        <svg class="spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>

        <div class="loadingText">Loading Application</div>
    </div>
</ng-container>

<ng-container *ngIf="!isLoadingData">
    <router-outlet *ngIf="!isIframe"></router-outlet>
</ng-container>